import { RoleConfig, StaticRole } from '@markant-platform/shared/user/model';
import { HeaderAndTableCellDraft, SortAttributes } from '@markant-platform/shared/table/model';

export const ROLE_CONFIG: RoleConfig[] = [
  {
    role: StaticRole.PLATFORM_ADMIN,
    routeIdentifier: new RegExp(
      /^\/(backoffice|organization)\/organizations\/[a-z0-9-]{24}\/members\/[a-z0-9-]{24}\/group-assignment/
    ),
    additionalConfig: {
      headline: ['dashboardOverview.groupAssignment.headline.groups'],
    },
  },
  {
    role: StaticRole.PLATFORM_ADMIN,
    routeIdentifier: new RegExp(/^\/backoffice\/users\/[a-z0-9-]{24}\/[a-z0-9-]{24}\/group-assignment/),
    additionalConfig: {
      headline: ['dashboardOverview.groupAssignment.headline.groups'],
    },
  },
  {
    role: StaticRole.ORGANIZATION_ADMIN,
    routeIdentifier: new RegExp(/^\/organization(\/organization-overview)?\/members\/[a-z0-9-]{24}\/group-assignment/),
    additionalConfig: {
      headline: ['dashboardOverview.groupAssignment.headline.groups'],
    },
  },
  {
    role: StaticRole.ORGANIZATION_ADMIN,
    routeIdentifier: new RegExp(/^\/organization\/group-assignment/),
    additionalConfig: {
      headline: ['dashboardOverview.groupAssignment.headline.myGroups'],
    },
  },
];

export const TABLE_HEADER_AND_CELLS: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'displayName',
    headerCellTranslationKey: 'dashboardOverview.groupAssignment.name',
    tableCellContentKey: 'displayName',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'memberCount',
    headerCellTranslationKey: 'dashboardOverview.groupAssignment.membersCount',
    tableCellContentKey: 'membersCount',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'createdAt',
    headerCellTranslationKey: 'dashboardOverview.groupAssignment.createdAt',
    tableCellContentKey: 'createdAt',
    tableCellContentType: 'DATE',
  },
];

export const DEFAULT_SORT: SortAttributes = {
  sortOrder: 'asc',
  sortField: 'displayName',
};
